import { ApartmentSets } from './apartment-sets.js';
import { RvDataListSets } from './rv-data/rv-data-list-sets.js';
import { AggConfigSets } from './agg-config-set.js';
import { RgDataSetID } from './rg-data-set-id.js';
import { getFloorOffsetFromApartment } from '../util/others/get-floor-offset-from-object.js';
import { getModuleWallThicknessFromApartment } from '../util/others/get-module-wall-thickness-from-apartment.js';
import { modulousIDs } from './rv-data/modulous-ids.js';

function createRougeDataSet(id) {
    return {
        id,
        rvData: RvDataListSets[id],
        aggConfig: AggConfigSets[id],
        apartments: {
            categories: getCategories(ApartmentSets[id]),
            all: ApartmentSets[id],
            main: ApartmentSets[id].filter(a => !a.data.closeCorridor),
            close: ApartmentSets[id].filter(a => a.data.closeCorridor),
            nextToEntrance: ApartmentSets[id].filter(a => a.data.nextToEntrance),
            aboveEntrance: ApartmentSets[id].filter(a => a.data.aboveEntrance)
        },
        floorOffset: getFloorOffsetFromApartment(ApartmentSets[id][0]),
        modulousIds: modulousIDs[id],
        externalModuleWallThickness: getModuleWallThicknessFromApartment(ApartmentSets[id][0])
    };
}
/**
 * Record of {@link RougeDataSet}, accessible via {@link RgDataSetID}
 */
const RougeDataSets = {
    [RgDataSetID.uk_01]: createRougeDataSet(RgDataSetID.uk_01),
    [RgDataSetID.uk_02]: createRougeDataSet(RgDataSetID.uk_02)
};
/**
 * given an array of apartments this function returns a record containing the description and members of the unit mix category
 */
function getCategories(apartments) {
    const categories = {};
    for (const a of apartments) {
        const categoryDescription = a.data.category;
        if (!categories[categoryDescription]) {
            categories[categoryDescription] = [];
        }
        categories[categoryDescription].push(a.name);
    }
    return categories;
}

export { RougeDataSets };
//# sourceMappingURL=rouge-data-sets.js.map
